import { HomeownerDashboard } from '../Breakpoint'
import MortgagesPanel from './MortgagesPanel'
import MortgagesModal from './MortgagesModal'

export const Mortgages = ({ onClickOutside }) => {
  return (
    <>
      <HomeownerDashboard.Small>
        <span>
          <MortgagesModal>
            <MortgagesPanel onClickOutside={onClickOutside} />
          </MortgagesModal>
        </span>
      </HomeownerDashboard.Small>
      <HomeownerDashboard.Large>
        <MortgagesPanel onClickOutside={onClickOutside} />
      </HomeownerDashboard.Large>
    </>
  )
}
